export default "/images/circle-xmark-light.svg?65e49f1498c875b5b44785120be04246";